export var RecordType;
(function (RecordType) {
    RecordType["GLOBAL"] = "global";
    RecordType["MASTER"] = "master";
    RecordType["CUSTOMER"] = "customer";
})(RecordType || (RecordType = {}));
